import { ExitFullScreenIcon } from '@radix-ui/react-icons';
import styles from './figure.module.css';

import { notoSerif } from '@/app/ui/fonts';

import { AspectRatio, Box } from '@radix-ui/themes';
import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { createPortal } from 'react-dom';

interface Props {
  src: string;
  alt: string;
  width: number;
  height: number;
  lightboxWidths: { initial: string; sm: string; md: string; lg: string };
  lightboxHeights: { initial: string; sm: string; md: string; lg: string };
  aspect: number;
  lightboxPortal: HTMLElement | null | undefined;
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default function Figure({
  src,
  alt,
  width,
  height,
  lightboxWidths,
  lightboxHeights,
  aspect,
  lightboxPortal,
  open,
  setOpen
}: Props) {
  return (
    <>
      <Box
        width={{ initial: '100%', sm: `${width}px` }}
        height={{ initial: '100%', sm: `${height}px` }}
      >
        <AspectRatio ratio={aspect}>
          <Box
            position='relative'
            width='100%'
            height='100%'
            className={`${notoSerif.className} ${styles.ImageWrapper}`}
            id='image-wrapper'
          >
            <Image
              src={src}
              alt={alt}
              fill
              sizes={'(max-width: 768px) 100vw, 300px'}
              className={styles.FullImage}
              onClick={() => setOpen(true)}
            />
          </Box>
        </AspectRatio>
      </Box>
      {lightboxPortal &&
        createPortal(
          <AnimatePresence>
            {open && (
              <AspectRatio ratio={aspect}>
                <motion.div
                  className={styles.LightboxBackdrop}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setOpen(false)}
                >
                  <Box
                    className={styles.LightboxWrapper}
                    width={{
                      initial: lightboxWidths.initial,
                      sm: lightboxWidths.sm,
                      md: lightboxWidths.md,
                      lg: lightboxWidths.lg
                    }}
                    height={{
                      initial: lightboxHeights.initial,
                      sm: lightboxHeights.sm,
                      md: lightboxHeights.md,
                      lg: lightboxHeights.lg
                    }}
                  >
                    <motion.div
                      className={styles.LightboxContent}
                      initial={{ scale: 0.5, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.5, opacity: 0 }}
                      transition={{ duration: 0.5 }}
                      onClick={e => e.stopPropagation()}
                    >
                      <Box
                        position='relative'
                        width={{
                          initial: lightboxWidths.initial,
                          sm: lightboxWidths.sm,
                          md: lightboxWidths.md,
                          lg: lightboxWidths.lg
                        }}
                        height={{
                          initial: lightboxHeights.initial,
                          sm: lightboxHeights.sm,
                          md: lightboxHeights.md,
                          lg: lightboxHeights.lg
                        }}
                        className={`${notoSerif.className} ${styles.ImageWrapper}`}
                      >
                        <Image
                          src={src}
                          alt={alt}
                          fill
                          sizes='100vw'
                          // className={styles.FullImage}
                        />
                      </Box>
                    </motion.div>
                    <div
                      id='close-image-button'
                      className={styles.FabButton}
                      onClick={e => {
                        e.stopPropagation();
                        setOpen(false);
                      }}
                    >
                      <ExitFullScreenIcon
                        width='1rem'
                        height='1rem'
                      />
                    </div>
                  </Box>
                </motion.div>
              </AspectRatio>
            )}
          </AnimatePresence>,
          lightboxPortal
        )}
    </>
  );
}
